import * as React from 'react';
import css from './ExploreSectionHead.module.scss';

interface Props extends React.HTMLProps<{}> {
  tag?: string;
}

class ExploreSectionHead extends React.PureComponent<Props> {
  public render() {
    // tslint:disable:no-any
    const Tag: any = this.props.tag || 'h2';
    return <Tag className={css.ExploreSectionHead}>{this.props.children}</Tag>;
  }
}

export default ExploreSectionHead;
